var console = require("./logger.js");
var Util = require("./util.js");
var Url = require("./url.js");
var JSON = require("./json3.mod.js");
var Oop = require("./oop.js");
//var $ = require("./jquery-1.11.2.mod.js");
var EventUtil = require("./eventutil.js");
var MessageProxy = require("./messageproxy.js");
var DPLocksmith = require("./DPLocksmith.js");

var CryptoJS = DPLocksmith.prototype.CryptoJS;


function FrameProxy () {

    FrameProxy._parent.constructor.apply(this, arguments);

    var me = this;

    this._messageCallbackWrapper = function (event) {

        //// for JQuery, use event.originalEvent
        //me._messageCallback(event.originalEvent);
        me._messageCallback(event);
    };
}
FrameProxy.name = "FrameProxy";

FrameProxy.validEncoder = (function() {

    var encoder = {};
    if(window.btoa != null && window.atob != null){
        // use native encoder if availble
        encoder.utf8ToB64 = function(str){
            return window.btoa(encodeURIComponent(str));
        };
        encoder.b64ToUtf8 = function(str){
            return decodeURIComponent(window.atob(str));
        };

    }else{
        // use encoder provided by DPLocksmith instead
        encoder.utf8ToB64 = function(str){
            var words = CryptoJS.enc.Utf8.parse(str);
            return CryptoJS.enc.Base64.stringify(words);
        };
        encoder.b64ToUtf8 = function(str){
            var words = CryptoJS.enc.Base64.parse(str);
            return CryptoJS.enc.Utf8.stringify(words);
        };

    }
    return encoder;

})();

Oop.extend(FrameProxy, MessageProxy);



FrameProxy.prototype._message = function (before, after) {

    if (before === 0 && after > 0) {

        //$(window).on("message", this._messageCallbackWrapper);
        EventUtil.onEvent(window, "message", this._messageCallbackWrapper);

    } else if (after === 0 && before > 0) {

        //$(window).off("message", this._messageCallbackWrapper);
        EventUtil.offEvent(window, "message", this._messageCallbackWrapper);
    }
};

FrameProxy.prototype._cloneTargetInfo = function (infoSrc) {

    var targetInfo = FrameProxy._parent._cloneTargetInfo.apply(this, arguments);

    if (targetInfo == null) {

        return null;
    }

    targetInfo.window = infoSrc.window;
    targetInfo.origin = infoSrc.origin;

    return targetInfo;
};


// interface impl.
FrameProxy.prototype._doPostMessage = function (messageObject) {

    var rawMessage = null;

    try {

        var jsonString = JSON.stringify(messageObject);

        rawMessage = FrameProxy.validEncoder.utf8ToB64(jsonString);

    } catch(e) {
        return;
    }

    var targetInfo = this.getTargetInfo();

    var origin = targetInfo.origin;

    if (origin == null) {

        origin = "*";
    }

    var targetWindow = targetInfo.window;

    function postMessage (me, targetWindow, rawMessage, origin) {

        try {

            targetWindow.postMessage(rawMessage, origin);

        } catch(e) {

            console.error(__GLOBAL_LOG_PREFIX__, "[" + me.constructor.name + "][_doPostMessage] Unable to post message");

            setTimeout(function () {

                me._doErrorCallback({
                    errorId: "Error." + messageObject.messageId + ".InvalidTarget",
                    message: "Invalid target",
                    senderId: me._senderId
                }, me);
            }, 0);
        }
    }

    if (Util.isIE() === true &&
        Util.isDocModeBelow(9) === true) {

        // postMessage is sync in IE document mode below 8,
        // make it asyn by using setTimeout
        var me = this;

        setTimeout(function () {

            if (Util.isWindowAvailable(targetWindow) === false) {

                console.warn(__GLOBAL_LOG_PREFIX__, "[" + me.constructor.name + "][_doPostMessage] Target window unavailable");
                return;
            }

            postMessage(me, targetWindow, rawMessage, origin);
            
        }, 0);

    } else {

        postMessage(this, targetWindow, rawMessage, origin);
    }
};

FrameProxy.prototype._createMessageObject = function (event) {

    var rawMessage = event.data;
    var origin = (event.origin === "null" ? null : event.origin);
    var source = event.source;

    var messageObject = null;

    try {

        var jsonString = FrameProxy.validEncoder.b64ToUtf8(rawMessage);

        messageObject = JSON.parse(jsonString);

    } catch(e) {}

    if (messageObject == null) {

         try{

            messageObject = JSON.parse(rawMessage);

        } catch(e) {}
    }

    if (messageObject != null) {

        // messageObject should not contain non-JSON object, might cause issues when
        // parsing.
        //messageObject.messageSource = source;
        messageObject.messageOrigin = origin;
    }

    return messageObject;
};

FrameProxy.prototype._isTargetInfoValid = function () {

    if (FrameProxy._parent._isTargetInfoValid.apply(this, arguments) === false) {

        return false;
    }

    var targetInfo = this.getTargetInfo();

    if (Util.isWindowAvailable(targetInfo.window) === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_isTargetInfoValid] Target window unavailable");
        return false;
    }

    return true;
};

FrameProxy.prototype._isSameOrigin = function (messageOrigin) {

    if (messageOrigin == null) {

        return false;
    }

    var targetInfo = this.getTargetInfo();

    if (targetInfo.origin == null || targetInfo.origin === "*") {

        return true;
    }

    if (messageOrigin.toLowerCase() === 
        targetInfo.origin.toLowerCase()) {

        return true;
    }

    return false;
};

FrameProxy.prototype._messageCallback = function (event) {

    if (event == null) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_messageCallback] Null event");
        return;
    }

    var targetInfo = this.getTargetInfo();
    var targetWindow = targetInfo.window;

    /* IE
    1. validWndA, validWndB
    2. validWndA, invalidWndB
    3. validWndA, null
    4. invalidWndA, validWndB
    5. null, validWndB
    6. invalidWndA, invalidWndB
    7. invalidWndA, null
    8. null, invalidWndB
    9. null, null
   10. validWndA, validWndA
   11. invalidWndA, invalidWndA
    */
    /* Other
    1. validWndA, validWndB
    2. validWndA, null
    3. null, validWndB
    4. null, null
    5. validWndA, validWndA
    */

    // window is not set
    if (Util.isSameWindow(targetWindow, null) === true) {

        return;
    }

    /* IE
    1. validWndA, validWndB
    2. validWndA, invalidWndB
    3. validWndA, null
    4. invalidWndA, validWndB
    6. invalidWndA, invalidWndB
    7. invalidWndA, null
   10. validWndA, validWndA
   11. invalidWndA, invalidWndA
    */
    /* Other
    1. validWndA, validWndB
    2. validWndA, null
    5. validWndA, validWndA
    */

    var messageWindow = Util.isWindowAvailable(event.source) ? event.source : null;

    if (messageWindow == null) {
        // window of message event has been unloaded

        /* IE
        2. validWndA, invalidWndB
        3. validWndA, null
        6. invalidWndA, invalidWndB
        7. invalidWndA, null
       11. invalidWndA, invalidWndA
        */
        /* Other
        2. validWndA, null
        */

        // Since we cannot compare it, continue to do origin check
        console.info(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_messageCallback] Unknown window!");

    } else {

        /* IE
        1. validWndA, validWndB
        4. invalidWndA, validWndB
       10. validWndA, validWndA
        */
        /* Other
        1. validWndA, validWndB
        5. validWndA, validWndA
        */
        if (Util.isSameWindow(targetWindow, messageWindow) === false) {

            /* IE
            1. validWndA, validWndB
            4. invalidWndA, validWndB
            */
            /* Other
            1. validWndA, validWndB
            */
            return;
        }

        /* IE
       10. validWndA, validWndA
        */
        /* Other
        5. validWndA, validWndA
        */
    }

    /* IE
    2. validWndA, invalidWndB
    3. validWndA, null
    6. invalidWndA, invalidWndB
    7. invalidWndA, null
   10. validWndA, validWndA
   11. invalidWndA, invalidWndA
    */
    /* Other
    2. validWndA, null
    5. validWndA, validWndA
    */
    var messageOrigin = (event.origin === "null" ? null : event.origin);

    // force origin check to insure that the message is actually from the origin we want
    /*
    1. originA, originA
    2. originA, originB
    3. originA, null
    4. * or null, originA
    5. * or null, originB
    6. * or null, null
    */
    var isSameOrigin = this._isSameOrigin(messageOrigin);

    if (isSameOrigin === false) {

        /*
        2. originA, originB
        3. originA, null
        6. * or null, null
        */
        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_messageCallback] Unexpected message origin!");
        return;
    }

    /*
    1. originA, originA
    4. * or null, originA
    5. * or null, originB
    */

    /*
    possible security holes
    a. messageObject.messageWindow = null (message from an about to unload frame)
    b. targetInfo.origin = null or * (topFrameProxy)
    c. static messageObject.senderId: topFrameProxy, extensionFrameProxy, topBarProxy

    => holes
    1. a: faking same domain frame unload message
    2. a + b + c: faking top frame message for frames that uses topFrameProxy, extensionProxy

    => prevention
    1. encrypt unload message
    2. PageLoad -> origin check
        ExtensionFrameReady -> origin check
        TopBarShown -> nothing harmful
        InitData -> ? (sessionId, tower url, encMasterPin)
    */

    var messageObject = this._createMessageObject(event);

    if (this._isValidMessage(messageObject) === false) {

        return;
    }

    this._doMessageCallback(messageObject, this);
};

FrameProxy.prototype.forwardMessage = function (messageObject) {

    messageObject.messageOrigin = "*";

    var targetInfo = this.getTargetInfo();

    if (targetInfo.origin != null) {

        messageObject.messageOrigin = targetInfo.origin;
    }

    // messageObject should not contain non-JSON object, might cause issues when
    // parsing.
    //messageObject.messageSource = targetInfo.window;

    FrameProxy._parent.forwardMessage.apply(this, [messageObject]);
};

FrameProxy.prototype._defaultTargetInfo = {
    targetId: "Message.Frame",
    window: null,
    origin: "*"
};

FrameProxy.prototype._targetType = "FrameWindow";

FrameProxy.prototype.hasSameTargetSource = function (messageProxy) {

    var myTargetInfo = this.getTargetInfo();
    var myTargetWindow = myTargetInfo.window;
    var targetInfo = messageProxy.getTargetInfo();
    var targetWindow = targetInfo.window;

    /* IE
    1. validWndA, validWndB
    2. validWndA, invalidWndB
    3. validWndA, null
    4. invalidWndA, validWndB
    5. null, validWndB
    6. invalidWndA, invalidWndB
    7. invalidWndA, null
    8. null, invalidWndB
    9. null, null
   10. validWndA, validWndA
   11. invalidWndA, invalidWndA
    */
    /* Other
    1. validWndA, validWndB
    2. validWndA, null
    3. null, validWndB
    4. null, null
    5. validWndA, validWndA
    */

    if (Util.isWindowAvailable(myTargetWindow) === false ||
        Util.isWindowAvailable(targetWindow) === false) {

        /* IE
        2. validWndA, invalidWndB
        3. validWndA, null
        4. invalidWndA, validWndB
        5. null, validWndB
        6. invalidWndA, invalidWndB
        7. invalidWndA, null
        8. null, invalidWndB
        9. null, null
       11. invalidWndA, invalidWndA
        */
        /* Other
        2. validWndA, null
        3. null, validWndB
        4. null, null
        */
        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][hasSameTargetSource] Unexpected window!");
        return false;
    }

    /* IE
    1. validWndA, validWndB
   10. validWndA, validWndA
    */
    /* Other
    1. validWndA, validWndB
    5. validWndA, validWndA
    */
    if (Util.isSameWindow(myTargetWindow, targetWindow) === false) {

        /* IE
        1. validWndA, validWndB
        */
        /* Other
        1. validWndA, validWndB
        */
        return false;
    }

    /* IE
   10. validWndA, validWndA
    */
    /* Other
    5. validWndA, validWndA
    */
    return true;
};

FrameProxy.prototype._targetInfoCheck = function (messageProxy) {

    var myTargetInfo = this.getTargetInfo();
    var targetInfo = messageProxy.getTargetInfo();

    if (myTargetInfo.targetId !== targetInfo.targetId) {

        return false;
    }

    return this.hasSameTargetSource(messageProxy);
};

module.exports = FrameProxy;